import { render, staticRenderFns } from "./formMove.vue?vue&type=template&id=5e290fba&"
import script from "./formMove.vue?vue&type=script&lang=js&"
export * from "./formMove.vue?vue&type=script&lang=js&"
import style0 from "./formMove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports